import { Utente } from "../authentication/authenticationSlice";

export const userIsLogged = (utente: Utente) => {
  // let isLogged = false;
  // Object.keys(utente).length !== 0 && (utente.isLogged = true);
  return utente.isLogged;
};
